(function () {
  var screensaver = document.querySelector('[data-idle-screensaver]');

  if (
    !screensaver ||
    screensaver.getAttribute('data-idle-screensaver-initialized') === 'true' ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return;
  }

  var stage = screensaver.querySelector('[data-idle-screensaver-stage]');
  var idleDelay = parseInt(screensaver.getAttribute('data-idle-delay'), 10) || 60000;
  var itemCount = parseInt(screensaver.getAttribute('data-item-count'), 10) || 8;
  var mobileItemCount = parseInt(screensaver.getAttribute('data-mobile-item-count'), 10) || 6;
  var desktopSizeScale = (parseInt(screensaver.getAttribute('data-size-scale'), 10) || 100) / 100;
  var mobileSizeScale = (parseInt(screensaver.getAttribute('data-mobile-size-scale'), 10) || 85) / 100;
  var forceNoOverlap = window.location.search.indexOf('idle-screensaver-no-overlap=1') !== -1;
  var preventOverlap = forceNoOverlap || screensaver.getAttribute('data-prevent-overlap') === 'true';
  var isThemeEditor = window.Shopify && window.Shopify.designMode;
  var editorPreview = isThemeEditor && screensaver.getAttribute('data-editor-preview') === 'true';
  var assets = [];
  var idleTimer;
  var isActive = false;
  var lastMovement = 0;
  var forcePreview = window.location.search.indexOf('idle-screensaver-preview=1') !== -1;
  var pausedMedia = [];

  screensaver.setAttribute('data-idle-screensaver-initialized', 'true');

  try {
    assets = JSON.parse(screensaver.getAttribute('data-assets') || '[]');
  } catch (error) {
    return;
  }

  function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  desktopSizeScale = Math.max(0.6, Math.min(desktopSizeScale, 1.4));
  mobileSizeScale = Math.max(0.5, Math.min(mobileSizeScale, 1.3));

  function shuffle(items) {
    var shuffledItems = items.slice();

    for (var index = shuffledItems.length - 1; index > 0; index -= 1) {
      var swapIndex = Math.floor(Math.random() * (index + 1));
      var item = shuffledItems[index];

      shuffledItems[index] = shuffledItems[swapIndex];
      shuffledItems[swapIndex] = item;
    }

    return shuffledItems;
  }

  function isLowPowerDevice() {
    return (
      (navigator.deviceMemory && navigator.deviceMemory <= 4) ||
      (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) ||
      window.innerWidth < 750
    );
  }

  function isMobileViewport() {
    return window.innerWidth < 750;
  }

  function getActiveItemCount() {
    return isMobileViewport() ? mobileItemCount : itemCount;
  }

  function getActiveSizeScale() {
    return isMobileViewport() ? mobileSizeScale : desktopSizeScale;
  }

  function getEffectiveItemCount() {
    var maxItems = isLowPowerDevice() ? 10 : 19;

    return Math.max(1, Math.min(getActiveItemCount(), maxItems, assets.length));
  }

  function setRandomPlacement(item, duration) {
    var size = (isMobileViewport() ? randomBetween(70, 125) : randomBetween(100, 180)) * getActiveSizeScale();
    var startRotation = randomBetween(-18, 18);

    item.style.setProperty('--idle-screensaver-x', randomBetween(-5, 90) + 'vw');
    item.style.setProperty('--idle-screensaver-size', size + 'px');
    item.style.setProperty('--idle-screensaver-duration', duration + 's');
    item.style.setProperty('--idle-screensaver-delay', -randomBetween(0, duration) + 's');
    item.style.setProperty('--idle-screensaver-drift', randomBetween(-8, 8) + 'vw');
    item.style.setProperty('--idle-screensaver-start-rotation', startRotation + 'deg');
    item.style.setProperty('--idle-screensaver-end-rotation', startRotation + randomBetween(-24, 24) + 'deg');
  }

  function buildNonOverlappingSlots(count, duration) {
    var viewportWidth = window.innerWidth;
    var columns = Math.ceil(Math.sqrt(count));
    var rows = Math.ceil(count / columns);
    var laneWidth = viewportWidth / columns;
    var maxSize = (isMobileViewport() ? 118 : 160) * getActiveSizeScale();
    var size = Math.min(maxSize, laneWidth * 0.62);
    var xJitter = Math.max(0, (laneWidth - size) * 0.34);
    var phaseJitter = Math.min(0.16, 0.38 / rows);
    var slots = [];
    var row;
    var column;

    for (row = 0; row < rows; row += 1) {
      var shuffledColumns = shuffle(Array.from({ length: columns }, function (_, columnIndex) {
        return columnIndex;
      }));

      for (column = 0; column < columns; column += 1) {
        slots.push({
          column: shuffledColumns[column],
          row: row
        });
      }
    }

    return shuffle(slots).slice(0, count).map(function (slot) {
      var x = slot.column * laneWidth + (laneWidth - size) / 2 + randomBetween(-xJitter, xJitter);
      var phase = (slot.row + 0.5) / rows + randomBetween(-phaseJitter, phaseJitter);

      return {
        duration: duration + randomBetween(-2, 2),
        phase: Math.max(0.05, Math.min(0.95, phase)),
        size: size,
        x: Math.max(0, Math.min(viewportWidth - size, x))
      };
    });
  }

  function setNonOverlappingPlacement(item, slot) {
    var startRotation = randomBetween(-10, 10);

    item.style.setProperty('--idle-screensaver-x', slot.x + 'px');
    item.style.setProperty('--idle-screensaver-size', slot.size + 'px');
    item.style.setProperty('--idle-screensaver-duration', slot.duration + 's');
    item.style.setProperty('--idle-screensaver-delay', -(slot.duration * slot.phase) + 's');
    item.style.setProperty('--idle-screensaver-drift', '0px');
    item.style.setProperty('--idle-screensaver-start-rotation', startRotation + 'deg');
    item.style.setProperty('--idle-screensaver-end-rotation', startRotation + randomBetween(-12, 12) + 'deg');
  }

  function buildItems() {
    var shuffledAssets = assets.slice().sort(function () {
      return Math.random() - 0.5;
    });
    var fragment = document.createDocumentFragment();
    var effectiveItemCount = getEffectiveItemCount();
    var duration = isLowPowerDevice() ? 24 : 20;
    var nonOverlappingSlots = preventOverlap ? buildNonOverlappingSlots(effectiveItemCount, duration) : [];

    stage.innerHTML = '';

    for (var index = 0; index < effectiveItemCount; index += 1) {
      var item = document.createElement('img');

      item.className = 'idle-screensaver__item';
      item.alt = '';
      item.decoding = 'async';
      item.draggable = false;
      item.src = shuffledAssets[index % shuffledAssets.length];

      if (preventOverlap) {
        setNonOverlappingPlacement(item, nonOverlappingSlots[index]);
      } else {
        setRandomPlacement(item, duration + randomBetween(-4, 4));
      }

      fragment.appendChild(item);
    }

    stage.appendChild(fragment);
  }

  function pauseBackgroundMedia() {
    pausedMedia = [];

    Array.prototype.forEach.call(document.querySelectorAll('video, audio'), function (media) {
      if (media.closest('[data-idle-screensaver]') || media.paused) {
        return;
      }

      try {
        media.pause();
        pausedMedia.push(media);
      } catch (error) {
        // Some embedded media can reject pause calls; ignore and keep the screensaver running.
      }
    });
  }

  function resumeBackgroundMedia() {
    pausedMedia.forEach(function (media) {
      if (!document.documentElement.contains(media)) {
        return;
      }

      var playPromise = media.play();

      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {});
      }
    });
    pausedMedia = [];
  }

  function activate() {
    if (document.hidden || isActive || assets.length === 0) {
      return;
    }

    buildItems();
    isActive = true;
    document.documentElement.classList.add('idle-screensaver-active');
    screensaver.classList.add('is-active');
    pauseBackgroundMedia();
  }

  function schedule() {
    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(activate, idleDelay);
  }

  function wake() {
    if (isActive) {
      isActive = false;
      document.documentElement.classList.remove('idle-screensaver-active');
      screensaver.classList.remove('is-active');
      resumeBackgroundMedia();
      window.setTimeout(function () {
        if (!isActive) {
          stage.innerHTML = '';
        }
      }, 500);
    }

    schedule();
  }

  function handleMouseMove() {
    var now = Date.now();

    if (isActive || now - lastMovement > 250) {
      lastMovement = now;
      wake();
    }
  }

  ['mousedown', 'touchstart', 'keydown', 'wheel', 'scroll'].forEach(function (eventName) {
    if (!editorPreview) {
      window.addEventListener(eventName, wake, { passive: true });
    }
  });
  if (!editorPreview) {
    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    document.addEventListener('visibilitychange', wake);
  }

  if (editorPreview || forcePreview) {
    window.setTimeout(activate, 500);
  } else {
    schedule();
  }
})();
